'use client'

/**
 * Purpose: Lazily loads the interactive NavbarLinks on the client, showing
 * NavbarLoading's static markup until mounted/hydrated.
 * Inputs: none.
 * Outputs: JSX — NavbarLoading fallback, then the real NavbarLinks.
 */

import { lazy, Suspense } from 'react'
import NavbarLoading from '@components/navbars/NavbarLoading/NavbarLoading'
import { useIsMounted } from '@/hooks/use-is-mounted'

const NavbarLinksLazy = lazy(() => import('@components/navbars/NavbarLinks/NavbarLinks'))

export default function NavbarLinksDynamic() {
  const mounted = useIsMounted()

  // Server-rendered HTML has no JS yet, so render the static fallback until
  // this client component confirms it has mounted.
  if (!mounted) return <NavbarLoading locale="" />

  return (
    <Suspense fallback={<NavbarLoading locale="" />}>
      <NavbarLinksLazy />
    </Suspense>
  )
}
